import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SolicitudesPublicadas from './components/SolicitudesPublicadas';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetalleSolicitud from './components/DetalleSolicitud';
import ParticiparSolicitud from './components/ParticiparSolicitud';
import CargarExcelPropuesta from './components/CargarExcelPropuesta';
import ParticipacionesProveedor from './components/ParticipacionesProveedor';
import DetalleParticipacion from './components/DetalleParticipacion';

function App() {
  return (
    <Router>
      <div className="App">
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
        <div className="container-fluid">
          <div className="row">
            {/* Sidebar */}
            <div className="col-md-2 bg-primary text-white min-vh-100 d-flex flex-column p-0" style={{ minHeight: '100vh' }}>
              <div className="p-3 border-bottom border-light d-flex flex-column align-items-center">
                <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" style={{ width: '64px', height: '64px', marginBottom: '10px' }} />
                <a className="navbar-brand text-white fw-bold" href="/">Gestión de Solicitudes</a>
              </div>
              <ul className="nav flex-column mt-4">
                <li className="nav-item mb-2 sidebar-item">
                  <a className="nav-link text-white" href="/">Solicitudes Publicadas</a>
                </li>
                <li className="nav-item mb-2 sidebar-item">
                  <a className="nav-link text-white" href="/participaciones">Participaciones por Proveedor</a>
                </li>
              </ul>
            </div>
            {/* Main content */}
            <div className="col-md-10 p-4">
              <Routes>
                <Route path="/" element={<SolicitudesPublicadas />} />
                <Route path="/detalle/:id" element={<DetalleSolicitud />} />
                <Route path="/participar/:id" element={<ParticiparSolicitud />} />
                <Route path="/cargar-excel/:id" element={<CargarExcelPropuesta />} />
                <Route path="/participaciones" element={<ParticipacionesProveedor />} />
                <Route path="/detalle-participacion/:consecutivo/:cedula" element={<DetalleParticipacion />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
